import React, { useState, useEffect } from "react";
import styles from "./ParkingFilter.module.css";
import RangeSlider from "../../../UI/RangeSlider/RangeSlider";
import SelectButton from "../../../UI/SelectButton/SelectButton";
import { ParkingCardData } from "../../../CardsComponents/types";
import { calculateDiscountedPrice } from "../../../../utils/discountPriceUtils";

export type FilterSmallState = {
  type: string[];
  price_range: [number, number];
};

type ParkingFilterProps = {
  onApplyFilter: (filteredData: ParkingCardData[]) => void;
  cardData: ParkingCardData[];
};

const ParkingFilter: React.FC<ParkingFilterProps> = ({ onApplyFilter, cardData }) => {
  const [filters, setFilters] = useState<FilterSmallState>({
    type: [],
    price_range: [0, 0],
  });

  const [priceLimits, setPriceLimits] = useState<[number, number]>([0, 0]);

  useEffect(() => {
    const prices = cardData.map((card) => {
      const discountedPrice = calculateDiscountedPrice(
        card.pricePerM2 ?? "0",
        card.discountProperty ?? 0,
        card.price ?? "0"
      );
      return parseInt(discountedPrice.replace(/\s+/g, ""), 10);
    });

    setPriceLimits([Math.min(...prices), Math.max(...prices)]);

    setFilters((prev) => ({
      ...prev,
      price_range: [Math.min(...prices), Math.max(...prices)],
    }));
  }, [cardData]);

  const toggleType = (type: string) => {
    setFilters((prev) => ({
      ...prev,
      type: prev.type.includes(type) ? prev.type.filter((t) => t !== type) : [...prev.type, type],
    }));
  };

  const updateRange = (key: keyof FilterSmallState, value: [number, number]) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const getFloorLabel = (floor: number): string => {
    if (floor === 0) return "Цоколь";
    return `${floor} этаж`;
  };

  useEffect(() => {
    const filtered = cardData.filter((card) => {
      const discountedPrice = calculateDiscountedPrice(
        card.pricePerM2 ?? "0",
        card.discountProperty ?? 0,
        card.price ?? "0"
      );
      const price = parseInt(discountedPrice.replace(/\s+/g, ""), 10);
      const floorLabel = getFloorLabel(card.floor);

      const matchesType = !filters.type.length || filters.type.includes(floorLabel);
      const matchesPrice = price >= filters.price_range[0] && price <= filters.price_range[1];

      return matchesType && matchesPrice;
    });

    onApplyFilter(filtered);
  }, [filters, cardData, onApplyFilter]);

  return (
    <div className={styles.filter}>
      <div className={styles.filter_select_buttons}>
        <SelectButton
          label="Цоколь"
          isActive={filters.type.includes("Цоколь")}
          onClick={() => toggleType("Цоколь")}
          theme="light"
        />
        <SelectButton
          label="1 этаж"
          isActive={filters.type.includes("1 этаж")}
          onClick={() => toggleType("1 этаж")}
          theme="light"
        />
        <SelectButton
          label="2 этаж"
          isActive={filters.type.includes("2 этаж")}
          onClick={() => toggleType("2 этаж")}
          theme="light"
        />
      </div>
      <RangeSlider
        min={priceLimits[0]}
        max={priceLimits[1]}
        value={filters.price_range}
        onChange={(value) => updateRange("price_range", value as [number, number])}
        label="₽"
        theme="light"
      />
    </div>
  );
};

export default ParkingFilter;